import Grid from '@picsart/grid/Grid';
import { ScreenSizes, Spacings } from '@picsart/cascade';
import { ReactNode } from 'react';

import testIds from 'pages/Batch/sections/Sidebar/RemoveBgTool/testIds';

interface ITextureGridProps {
    children: ReactNode;
}

const TextureGrid = ({ children }: ITextureGridProps) => (
  <Grid
    dataTestId={testIds.textureGrid}
    columns={{
      [ScreenSizes.LG]: 'repeat(3, 1fr)',
      [ScreenSizes.SM]: 'repeat(4, 1fr)',
    }}
    gap={{
      [ScreenSizes.LG]: Spacings.s12,
      [ScreenSizes.SM]: Spacings.s8,
    }}
  >
    {children}
  </Grid>
);

export default TextureGrid;
